<template>

  <v-container fluid class="page page-provider-connection-list">

    <!-- Breadcrumb & actions -->
    <v-row class="mt-4 mb-8">
      <v-col cols="8" class="d-flex align-center justify-start page-breadcrumb-new">
        <v-icon small class="mr-2">mdi-link</v-icon>
        <div>Shipper Accounts</div>
      </v-col>
      <v-col cols="4" align="right">
        <!-- (add connection menu) -->
        <v-menu offset-y v-if="!isDataLoading">
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="light-blue darken-1" class="pr-2" v-bind="attrs" v-on="on">
              + Add Connection
              <v-icon class="pl-1">mdi-menu-down</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item v-for="(provider, index) in availableProviders" :key="index">
              <v-btn plain @click="goToCreateConnectionPage(provider.alias)">{{ provider.label }}</v-btn>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-col>
    </v-row>

    <!-- (data loading spinner) -->
    <v-container class="mt-12 d-flex flex-column align-center justify-center" v-if="isDataLoading">
      <v-progress-circular indeterminate :size="50" style="margin-bottom:30px" color="primary" />
    </v-container>

    <!-- (loading error) -->
    <template v-else-if="dataLoadingError">
      <v-row class="mt-2">
        <v-col class="d-flex align-center justify-center">
          <div class="info-text">Connections could not be loaded.</div>
        </v-col>
      </v-row>
      <v-row class="mt-4">
        <v-col align="center">
          <v-row class="mb-5 align-center justify-center error-item">
            <v-col cols="1" align="center">
              <v-icon color="red">mdi-alert-circle-outline</v-icon>
            </v-col>
            <v-col cols="11" align="left">
              <span>{{ dataLoadingError }}</span>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row class="mt-0">
        <v-col align="center">
          <v-btn text color="primary" @click="loadProviderConnections(true)">
            <v-icon class="mr-2" style="font-size:16px" color="primary">mdi-refresh</v-icon>
            Retry
          </v-btn>
        </v-col>
      </v-row>
    </template>

    <!-- Existing provider connections -->
    <v-container fluid class="px-0" v-else-if="hasProviderConnections">
      <provider-connection-card
          class="mb-10"
          v-for="(connection, index) in providerConnectionItems"
          :key="index"
          :connection="connection"
          v-on:editConnection="goToEditConnectionPage(connection)">
      </provider-connection-card>
    </v-container>

    <!-- No existing connections -->
    <v-container fluid class="mt-10" v-else>
      <v-row align="center" justify="center">
        <v-col cols="12" xs="12" sm="12" md="10" lg="8" class="py-6 d-flex aling-center justify-center no-connections-message-container">
          <v-icon color="amber darken-2" class="pr-3">mdi-alert-circle-outline</v-icon>
          <div class="no-connections-message-text">
            Connect to an order provider to submit orders with {{ appName }}
          </div>
        </v-col>
      </v-row>
    </v-container>

  </v-container>

</template>

<script>
import ProviderConnectionCard from '@/components/providerConnections/ProviderConnectionCard'

export default {
  name: 'ProviderConnectionListPage',

  components: {
    ProviderConnectionCard
  },

  data () {
    return {
      isDataLoading: false,
      dataLoadingError: null
    }
  },

  computed: {
    appName () {
      return this.$store.getters['app/platform']
    },
    providerConnections () {
      return this.$store.getters['sh/data']('providerConnections')
    },
    providerConnectionItems () {
      return this.providerConnections ? this.providerConnections.items : []
    },
    hasProviderConnections () {
      return this.providerConnectionItems.length > 0
    },
    availableProviders () {
      // return [
      //   { alias: 'leaflink', label: 'LeafLink' },
      //   { alias: 'leaftrade', label: 'LeafTrade' }
      // ]
      return [
        { alias: 'leaflink', label: 'LeafLink' }
      ]
    }
  },

  async beforeMount () {
    // Ensure provider connections are loaded
    await this.loadProviderConnections(true)
  },

  methods: {
    // Go to create a new connection page
    goToCreateConnectionPage (providerAlias) {
      this.$root.goTo('provider-connection-create', { providerAlias })
    },

    // Go to edit connection page
    goToEditConnectionPage (connection = {}) {
      this.$store.dispatch('sh/setItemToEdit', connection) // set item to edit
      this.$root.goTo('provider-connection-edit', { connectionId: connection.id })
    },

    // Load all provider connections
    async loadProviderConnections (force) {
      this.isDataLoading = true
      this.dataLoadingError = null

      try {
        // Load all provider connections
        await this.$store.dispatch('sh/dataApi', {
          method: 'load',
          uri: 'provider-connections',
          opts: {
            resource: 'providerConnections',
            params: { with: 'shipper' },
            all: true,
            force
          }
        })
      } catch (err) {
        this.dataLoadingError = err.message || err.text || err
      } finally {
        this.isDataLoading = false
      }
    }
  }
}
</script>

<style scoped>
  /* Info text for processing and results display */
  .page-provider-connection-list .info-text {
    font-size: 1.04rem;
    color: #a2a2a2;
  }

  .page-provider-connection-list .no-connections-message-container {
    border: 1px solid #FF9D29;
    border-radius: 4px;
  }

  .page-provider-connection-list  .no-connections-message-text {
    font-size: 1.08rem;
    color: #FF9D29;
  }

  /* Error display */
  .page-provider-connection-list .error-item {
    color: #F44336;
    font-size: 0.9rem;
    border: 1px solid #F44336;
    border-radius: 4px;
    padding: 3px 3px;
    max-width: 500px;
  }
</style>
